import { render, staticRenderFns } from "./SpotlightHeader.vue?vue&type=template&id=59ee6fe6&scoped=true"
import script from "./SpotlightHeader.vue?vue&type=script&lang=js"
export * from "./SpotlightHeader.vue?vue&type=script&lang=js"
import style0 from "./SpotlightHeader.vue?vue&type=style&index=0&id=59ee6fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ee6fe6",
  null
  
)

export default component.exports